import { useCallback, useState } from "react";
import moment from "moment";
import { FiltroRelatorioReceitaDespesaAnual } from "core/features/relatorios/typings";


function useFiltroRelatorioReceitaDespesaAnual() {
  const [filtro, setFiltro] = useState<FiltroRelatorioReceitaDespesaAnual>({
    search: "",
    statusId: undefined,
    contaBancariaIds: undefined,
    contaCategoriaIds: undefined,
    ano: moment().format("YYYY"),
    operacao: undefined,
  });

  const onChangeFiltro = useCallback(
    (_filtro: Partial<FiltroRelatorioReceitaDespesaAnual>) => {
      setFiltro((state) => ({ ...state, ..._filtro }));
    },
    []
  );

  return {
    filtro,
    setFiltro,
    onChangeFiltro,
  };
}

export default useFiltroRelatorioReceitaDespesaAnual;
